import { lazy } from "react";

export { MY_VACANCIES_LIST_PATH } from "./my-vacancies-list-path";
export const MyVacanciesListPage = lazy(() => import("./my-vacancies-list"));
